import { API_REQUEST, GET_REPORTS, RESET_REPORTS } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction } from "../../types";

// Download document action
export const getReports = (roll_num: string, property_id: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/documents/get-reports/${roll_num}/${property_id}`,
        next: GET_REPORTS,
        method: 'GET',
        authorization: true,
    }
});

export const resetReports = (): AppNoApiAction => ({
    type: RESET_REPORTS
});
